export default {
  BASE_API_URL: 'https://starbe.services-money91.com/base',
  BASE_API_URL_MALL: 'https://groupbuybe.payboard.in/saleService',
  // BASE_PAYMENT_URL: 'https://test4.services-money91.com/star91',
  BASE_PAYMENT_URL: 'https://starbe.services-money91.com'
}
